import React, {Component} from 'react';
import './share.scss';

import API from './../../config/api';

import {connect} from 'react-redux';
import {refresh_admin} from './../../redux/models/admin';

@connect(
  state => ({admin: state.admin}),
  {refresh_admin}
)

class Share extends Component {
  constructor(props) {
    super(props);
    this.state = {};

  }

  componentWillMount() {
    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bjnews.dongcheng';
    // $('html,body,#root').css({
    //     height: '100%'
    // })\
    // this.ymstatistics()

    return false;
    // var userAgent = this.userAgent();
    // if (userAgent === 0) {   // ios
    //   window.location.href = 'http://itunes.apple.com/cn/app/id1459595192?mt=8'
    // } else if (userAgent === 1) { // 安卓 通过应用宝
    //   window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bjnews.dongcheng';
    // }
  }

  componentDidMount() {
    // this.initWx({});
  }

  componentWillUnmount() {

  }

  userAgent = () => {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 0;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      return 1;
    }
  };

  // shouldComponentUpdate() {
  //
  // }



  ymstatistics() {
    setTimeout(() => {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl], refererUrl)
      } else {
        console.log('_czc null')
      }
    }, 2000)
  }

  openApp() {
    window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bjnews.dongcheng';
  }

  initWx(obj) {
    //分享
    var wxconfig = new window.WxConfig();
    console.log(window.location.href);
    wxconfig.init({
      appid: API.appid,
      url: window.location.href,
      title: obj.title || API.share_title,
      desc: obj.desc || API.share_des,
      link: window.location.href,
      imgUrl: API.share_img,
    });
  }
  render() {

    return (
      <div className="share-box">
        <div className="bottom-box">
          <div className="text-box">好新闻 无止境</div>
          <div className="open-app-btn" onClick={this.openApp}>打开北京东城App</div>
        </div>
      </div>
    );
  }
}

export default Share;


// WEBPACK FOOTER //
// ./src/pages/Share/share.js